/**
 * Dataset API endpoints, merged into the platform API client by the
 * extension mechanism. Contracts live in waraka_extensions.reuse.api.
 */
export const reuseApiEndpoints: Record<string, string> = {
  datasets: "GET:/ext/reuse/datasets/",
  createDataset: "POST:/ext/reuse/datasets/",
  dataset: "GET:/ext/reuse/datasets/:pk/",
  updateDataset: "PATCH:/ext/reuse/datasets/:pk/",
  deleteDataset: "DELETE:/ext/reuse/datasets/:pk/",
  datasetItems: "GET:/ext/reuse/datasets/:pk/items/",
  removeDatasetItems: "DELETE:/ext/reuse/datasets/:pk/items/",
  datasetSources: "GET:/ext/reuse/datasets/:pk/sources/",
  datasetFillPlan: "POST:/ext/reuse/datasets/:pk/fill-plan/",
  newDatasetFillPlan: "POST:/ext/reuse/datasets/fill-plan/",
  datasetFill: "POST:/ext/reuse/datasets/:pk/fill/",
  datasetTakeFiles: "POST:/ext/reuse/datasets/:pk/take-files/",
  datasetStore: "POST:/ext/reuse/datasets/:pk/store/",
  datasetAbsorb: "POST:/ext/reuse/datasets/:pk/absorb/",
  projectDatasetStatus: "GET:/ext/reuse/projects/:pk/status/",
  projectDatasets: "GET:/ext/reuse/projects/:pk/datasets/",
  reusePlan: "POST:/ext/reuse/projects/:pk/plan/",
  reuseBring: "POST:/ext/reuse/projects/:pk/bring/",
};
